import { Api } from "@/services/ApiService"
import { SchultenMedia } from "@/services/DataService"
import type { TenantFeatures } from "@/types/tenant.types"

class TenantService {
    async getFeatures(): Promise<{ success: boolean; message: string; data?: TenantFeatures }> {
        try {
            const dataResult = await Api.get(SchultenMedia.API.tenant.features)
            const data = dataResult.ok ? dataResult.data : null

            if (!data || data?.error) {
                return {
                    success: false,
                    message: data?.message || "Failed to fetch tenant features.",
                }
            }

            return {
                success: true,
                message: "Successfully fetched tenant features",
                data: data?.data ?? data,
            }
        } catch (error) {
            console.error("TenantService Error:", error)
            return {
                success: false,
                message: "An unexpected error occurred while fetching tenant features",
            }
        }
    }
}

export default new TenantService()
